import {
    HomeIcon,
    CompanyIcon,
    SolutionsIcon,
    ResourcesIcon,
    CareersIcon,
    ContactIcon,
    LanguageIcon
} from '../components/layout/NavIcons';

export interface Tab {
    title: string;
    key?: string; // Added key for translations
    icon: React.ComponentType<{ className?: string }>;
    url?: string;
    onClick?: () => void;
    dropdown?: boolean;
    items?: { id: number; title: string; key?: string; url: string; category?: string }[];
}

export interface Separator {
    type: "separator";
}

export type TabItem = Tab | Separator;

export const getNavigation = (language: string, toggleLang: () => void, t: (key: string) => string): TabItem[] => {
    return [
        { title: t('nav.home'), key: 'nav.home', icon: HomeIcon, url: '/' },
        { type: "separator" },
        {
            title: t('nav.company'), key: 'nav.company', icon: CompanyIcon, dropdown: true,
            items: [
                { id: 1, title: t('nav.who_we_are'), key: 'nav.who_we_are', url: '/company/who-we-are#who-we-are' },
                { id: 2, title: t('nav.culture'), key: 'nav.culture', url: '/company/who-we-are#corporate-culture' },
                { id: 3, title: t('nav.people'), key: 'nav.people', url: '/company/who-we-are#key-people' },
            ]
        },
        { type: "separator" },
        {
            title: t('nav.solutions'), key: 'nav.solutions',
            icon: SolutionsIcon,
            dropdown: true,
            items: [
                // Merchant Solutions
                { id: 1, title: t('nav.payment_solutions'), key: 'nav.payment_solutions', url: '/services/payment-solutions', category: 'merchant' },
                { id: 2, title: t('nav.integrated_solutions'), key: 'nav.integrated_solutions', url: '/services/integrated-solutions', category: 'merchant' },
                { id: 3, title: t('nav.online_solutions'), key: 'nav.online_solutions', url: '/services/online-solutions', category: 'merchant' },
                { id: 4, title: t('nav.value_added_services'), key: 'nav.value_added_services', url: '/services/value-added-services', category: 'merchant' },
                // Issuer Solutions
                { id: 5, title: t('nav.card_processing_solutions'), key: 'nav.card_processing_solutions', url: '/services/card-processing-solutions', category: 'issuer' },
                { id: 6, title: t('nav.loyalty_solutions'), key: 'nav.loyalty_solutions', url: '/services/loyalty-solutions', category: 'issuer' },
                { id: 7, title: t('nav.fraud_management'), key: 'nav.fraud_management', url: '/services/fraud-management', category: 'issuer' },
                { id: 8, title: t('nav.lets_get_started'), key: 'nav.lets_get_started', url: '/services/get-started', category: 'issuer' },
                // Get Started
                { id: 9, title: t('nav.get_started'), key: 'nav.get_started', url: '/get-started', category: 'cta' },
            ]
        },
        { type: "separator" },
        {
            title: t('nav.resources'), key: 'nav.resources', icon: ResourcesIcon, dropdown: true,
            items: [
                { id: 1, title: t('nav.support_center'), key: 'nav.support_center', url: '/resources/support-center', category: 'merchant' },
                { id: 2, title: t('nav.learning_center'), key: 'nav.learning_center', url: '/resources/learning-center', category: 'merchant' },
                { id: 3, title: t('nav.pci_compliance'), key: 'nav.pci_compliance', url: '/resources/pci-compliance', category: 'merchant' },
                { id: 4, title: t('nav.partner_services'), key: 'nav.partner_services', url: '/resources/partner-services', category: 'merchant' },
            ]
        },
        { type: "separator" },
        {
            title: t('nav.careers'), key: 'nav.careers', icon: CareersIcon, dropdown: true, items: [
                { id: 1, title: t('nav.work_at_fintek'), key: 'nav.work_at_fintek', url: '/careers', category: 'merchant' },
                { id: 2, title: t('nav.culture'), key: 'nav.culture', url: '/careers#culture', category: 'merchant' },
                { id: 3, title: t('nav.apply_today'), key: 'nav.apply_today', url: '/careers#careers', category: 'merchant' },
            ]
        },
        { type: "separator" },
        { title: t('nav.contact'), key: 'nav.contact', icon: ContactIcon, url: '/contact' },
        { type: "separator" },
        { title: t('nav.language'), key: 'nav.language', icon: LanguageIcon, onClick: toggleLang },
    ];
};
